<template>
    <div>
        <div id="echarts" class="echarts" ref="echarts"></div>
    </div>
</template>

<script>
    import echarts from "echarts"
    export default {
        name: 'flowE2',
        props: {
            // 接收父组件传递过来的信息
            chartData: {
                type: Object,
            }
        },
        data () {
            return {}
        },
        methods: {
            drawChart () {
                let vm = this
                var myChart = echarts.init(document.getElementById('echarts'));
                myChart.setOption({
                    title: {
                        text: 'Gradient Stacked Area Chart'
                    },
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'cross',
                            label: {
                                backgroundColor: '#6a7985',
                            }
                        }
                    },
                    legend: {
                        data: ['Line 1']
                    },
                    toolbox: {
                        feature: {
                            saveAsImage: {}
                        }
                    },
                    grid: {
                        left: '3%',
                        right: '4%',
                        bottom: '3%',
                        containLabel: true
                    },
                    xAxis: {
                            type: 'category',
                            boundaryGap: false,
                            data: vm.chartData.x_data,
                            splitLine:{
                                show:false
                            },
                            axisTick:{       //y轴刻度线
                                show: false
                            },
                            axisLabel: {
                                rotate: 40,
                                textStyle: {
                                    color: '#7B7BA2',
                                    marginTop: '30px'
                                }
                            },
                            axisLine: {
                                show: true,
                                lineStyle: {
                                    color:'#7B52DE',//刻度线的颜色
                                }
                            },
                        }
                    ,
                    yAxis: {
                        type: 'value',
                        axisTick:{       //y轴刻度线
                            show: false
                        },
                        axisLabel: {
                            textStyle: {
                                color: '#333'
                            }
                        },
                        splitLine:{
                            show: true,
                            lineStyle: {
                                color: '#5F5F7F',
                                type: 'dashed',
                            }
                        },
                        axisLine: {
                            show: true,
                            lineStyle: {
                                color: '#8659F8',//刻度线的颜色
                            },
                            textStyle: {
                                color: '#6A6A8C'
                            }
                        },
                    },
                    series: [
                        {
                            name: 'Line 1',
                            type: 'line',
                            stack: 'Total',
                            smooth: true,
                            lineStyle: {
                                width: 0
                            },
                            showSymbol: false,
                            areaStyle: {
                                opacity: 0.15,
                                color: {
                                    type: "linear",
                                    x: 0,
                                    y: 0,
                                    x2: 0,
                                    y2: 1,
                                    colorStops: [
                                        {
                                            offset: 0,
                                            color: '#7B52DE',
                                        },
                                        {
                                            offset: 1,
                                            color: "#7B52DE",
                                        },
                                    ],
                                    globalCoord: false, // 缺省为 false
                                }
                            },
                            itemStyle : {
                                normal : {
                                    color:'#707070',
                                    label: {
                                        show: true,
                                    },
                                    lineStyle:{
                                        color:'#8659F8',
                                    }
                                }
                            },
                            emphasis: {
                                focus: 'series'
                            },
                            data: vm.chartData.y_data
                        }
                    ]
                });
            }
        },
        mounted () {
            const vm = this
            vm.$nextTick(()=> {
                vm.drawChart()
            })
        },
        created: () => {}
    }
</script>
<style lang="scss">
    .echarts{
        width: 100%;
        height: 400px;
    }
</style>
